const r = [
  "{win}",
  "{arrow-right}",
  "{arrow-left}",
  "{arrow-up}",
  "{arrow-down}",
  "{cmd}",
  "{opt}"
];
export {
  r as SHORTCUTS_ALIASES_LIST
};
//# sourceMappingURL=keyboard-shortcut-constants.js.map
